import {
  Box,
  CircularProgress,
  DialogContent,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import useDebouncedEffect from '@treyd-io/core/hooks/useDebouncedEffect';
import WarningTriangleIcon from '@treyd-io/treyd-ui/icons/WarningTriangleIcon';
import { useTranslation } from 'react-i18next';
import { useEffectOnce } from 'react-use';

interface Props {
  cancelSignCallback: () => void;
  signCallback: () => void;
  isPollingData: boolean;
  scriveUrl?: string;
  error?: string;
}

export const BankIdConnectionBody = (props: Props) => {
  const { cancelSignCallback, signCallback, isPollingData, scriveUrl, error } =
    props;
  const { t } = useTranslation();

  useEffectOnce(() => {
    cancelSignCallback();
  });

  useDebouncedEffect(
    () => {
      isPollingData && signCallback();
    },
    [isPollingData],
    2000
  );

  return (
    <DialogContent>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        bgcolor={'grey.200'}
        paddingX={8}
        paddingY={6}
        borderRadius={2}
        marginY={2}>
        {error ? (
          <Stack gap={3} alignItems="center" textAlign="center">
            <WarningTriangleIcon
              color="error"
              width={64}
              height={64}
              sx={{ fontSize: 64 }}
            />
            <Typography variant="body1">{error}</Typography>
          </Stack>
        ) : (
          <>
            <CircularProgress />
            <br />
            <Stack alignItems={'center'} marginY={1} textAlign="center">
              <Typography variant="body2" color="textPrimary">
                {t('follow_instruction_in_same_tab_title')}
              </Typography>
              {scriveUrl && (
                <Typography variant="body2" color="textPrimary">
                  {t('follow_instruction_in_same_tab_subtitle')}{' '}
                  <Link href={scriveUrl || ''} target="_blank">
                    {t('this_link')}
                  </Link>
                </Typography>
              )}
            </Stack>
          </>
        )}
      </Box>
    </DialogContent>
  );
};
